import { queryItemNameGroup } from "../js/query/item-name-groups.js";
import { itemNameGroupView, sharedItemGroupGrade } from "../js/query/item-group-presentation.js";
import { mapCountText, siteText } from "./map-i18n.js";
import { specialItemIdentity } from "./map-special-item-references.js";

function normalizedItemIds(values) {
  return (Array.isArray(values) ? values : [])
    .map((value) => Number.parseInt(value, 10))
    .filter((value, index, all) =>
      Number.isInteger(value) && value > 0 && all.indexOf(value) === index
    );
}

function itemGroupMember(itemId, itemLookup) {
  const item = itemLookup instanceof Map ? itemLookup.get(itemId) : null;
  return {
    ...(item || {}),
    itemId,
    name: String(item?.name || item?.label || `Item ${itemId}`).trim(),
  };
}

function orderedItemGroupIds(term, special) {
  const semanticItemIds = normalizedItemIds(term?.itemIds);
  const semanticItemIdSet = new Set(semanticItemIds);
  const configuredSections = Array.isArray(special?.displaySections)
    ? special.displaySections
    : [];
  const configuredItemIds = configuredSections
    .flatMap((section) => normalizedItemIds(section?.itemIds))
    .filter((itemId, index, all) =>
      semanticItemIdSet.has(itemId) && all.indexOf(itemId) === index
    );
  const configuredItemIdSet = new Set(configuredItemIds);
  return [
    ...configuredItemIds,
    ...semanticItemIds.filter((itemId) => !configuredItemIdSet.has(itemId)),
  ];
}

export function buildItemGroupPresentationModel(
  term,
  itemLookup,
  special,
  resolveGrade,
) {
  if (typeof resolveGrade !== "function") {
    throw new TypeError("item-group presentation requires a grade resolver");
  }
  const itemIds = normalizedItemIds(term?.itemIds);
  const directMembers = orderedItemGroupIds(term, special)
    .map((itemId) => itemGroupMember(itemId, itemLookup));
  const sameName = !term.sourceKinds?.length && queryItemNameGroup(directMembers);
  const nameGroup = sameName ? itemNameGroupView(directMembers, siteText) : null;
  const identity = special && !nameGroup
    ? specialItemIdentity(
        special,
        itemLookup instanceof Map ? itemLookup.get(special?.itemId) || {} : {},
      )
    : null;
  const label = nameGroup?.label || identity?.name || mapCountText("search.item_group.items", itemIds.length);
  return {
    directMembers,
    nameGroup,
    directMemberNames: directMembers.map((member) => member.name),
    identity,
    itemIds,
    label,
    grade: nameGroup ? nameGroup.grade : identity
      ? resolveGrade(identity)
      : sharedItemGroupGrade(directMembers, resolveGrade),
    isSpecial: Boolean(special) && !nameGroup,
  };
}
